<template>
  <div class="new-checkbox" :class="[{ isChecked: check }]" @click="toggle">
    <input class="new-checkbox__input" type="checkbox" />
    <div class="new-checkbox__marker">
      <div class="new-checkbox__icon" v-show="check">
        <icon name="new_vektor"></icon>
      </div>
      <!-- <div class="new-checkbox__icon" v-show="!">
        <icon name="new_vektor-minus"></icon>
      </div> -->
    </div>
    <div class="new-checkbox__label" v-if="label">{{ label }}</div>
  </div>
</template>

<script>
export default {
  props: {
    check: {
      type: Boolean,
      default: false
    },
    label: {
      type: String
    }
  },
  methods: {
    toggle() {
      console.log('ya tyt');
      this.$emit('checkedElem');
    }
  }
};
</script>

<style scoped lang="scss">
.new-checkbox {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  gap: 8px;
  &__input {
    display: none;
  }
  &__marker {
    border: 1px solid #c7cfdd;
    border-radius: 8px;
    width: 24px;
    height: 24px;
    transition: 0.3s;
  }
  &__icon {
    transition: 0.3s;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
      width: 16px;
      height: 16px;
    }
  }
  &__label {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    text-align: right;
    color: #38455d;
  }
  &:hover {
    .new-checkbox {
      &__marker {
        border: 1px solid #409fff;
        background: #eef7ff;
      }
    }
  }
  &.isChecked {
    .new-checkbox {
      &__marker {
        border: 1px solid #409fff;
        background: #409fff;
      }
    }
  }
}
</style>
